// src/utils/formatDate.js
export default function formatDate(dateStrOrObj) {
    let d = typeof dateStrOrObj === "string" ? new Date(dateStrOrObj) : dateStrOrObj;
    if (!(d instanceof Date) || isNaN(d)) return "";
    const day = String(d.getDate()).padStart(2, '0');
    const month = d.toLocaleString('en-US', { month: 'short' }); // Jan, Feb, ...
    const year = d.getFullYear();
    return `${day}/${month}/${year}`;
  }